export function isActive() {
	return process.env.NODE_ENV === "production";
}

export function init() {
	if (!isActive()) { return; }

	!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
	n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
	n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
	t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
	document,'script','//connect.facebook.net/en_US/fbevents.js');

	fbq('init', '888301704521459');
	fbq('track', "PageView");
}

export function upgrade(value) {
	if (!isActive()) { return; }

	fbq('track', 'Subscribe', { 
	    value: 10,
	    currency: 'USD'
	});

}


// WEBPACK FOOTER //
// ./modules/lib/integrations/FacebookPixelClient.js